/**
 * This file is created manually
 * You can change the content
 *
 */

import H1 from './typography/H1'
export * from './typography/H1'
export default H1
